






















































































































































































import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import {
  Article,
  NewsModel,
  SearchNewsModel,
} from "@/api/models/accesPlateformeBeneficiaires/news";
import {
  BAlert,
  BCardImg,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BBadge,
  BRow,
  BSpinner,
  BModal,
  BCardTitle,
  BCardText,
  BCardFooter,
  BPagination,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import CreateNews from "./CreateNews.vue";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import UpdateNews from "./UpdateNews.vue";
import TagInput from "@/components/inputs/TagInput.vue";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import DetailsNews from "./DetailsNews.vue";

@Component({
  name: "ptf-beneficiaire-news",
  components: {
    BCard,
    FeatherIcon,
    BSpinner,
    BCardBody,
    BPagination,
    BCol,
    BBadge,
    BRow,
    BAlert,
    BButton,
    BCardTitle,
    BCardText,
    BCardImg,
    BModal,
    CreateNews,
    BCardFooter,
    UpdateNews,
    TagInput,
    SearchableVueSelect,
    DetailsNews,
  },
})
export default class NewsList extends Vue {
  showCreateModal = false;
  showEditModal = false;
  showDetailsModal = false;

  isLoading = false;

  tagsList: string[] = [];

  newsToUpdate: NewsModel | null = null;

  listArticles: PaginatedList<Article> = new PaginatedList<Article>();
  totalCountArticles = 0;

  searchNewsModel: SearchNewsModel = {
    pageNumber: 1,
    pageSize: 10,
    tags: [],
    motCles: [],
  };

  selectedNews: Article | null = null;

  mounted() {
    this.loadListArticles();
    this.loadListTags();
  }

  @Watch("searchNewsModel", { deep: true, immediate: false })
  reloadList() {
    this.loadListArticles();
    this.loadListTags();
  }

  private async loadListTags() {
    this.$http.myressif.parametres
      .getByNom("news_tags_list")
      .then((tags: any) => {
        this.tagsList = JSON.parse(tags?.valeur ?? "[]");
      })
      .catch(() => {
        errorAlert.fire({
          title: "Erreur de chargement",
          text: "Impossible de charger la liste des tags.",
        });
      });
  }

  private async loadListArticles() {
    this.isLoading = true;
    this.$http.myressif.ptfBeneficiaireNews
      .searchNews(this.searchNewsModel)
      .then((response: PaginatedList<Article>) => {
        this.listArticles = response;
        this.totalCountArticles = response.totalCount;
      })
      .catch((error: any) => {
        errorAlert.fire({
          title: "Erreur",
          text: "Une erreur s'est produite lors du chargement des articles.",
          icon: "error",
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  editNews(newsToUpdate: Article) {
    this.newsToUpdate = {
      id: newsToUpdate.id,
      titre: newsToUpdate.titre,
      contenu: newsToUpdate.contenu,
      resume: newsToUpdate.resume,
      motCles: newsToUpdate.motCles,
      tags: newsToUpdate.tags,
    };

    this.showEditModal = true;
  }

  
  openDetails(article: Article) {
    this.selectedNews = article;
    this.showDetailsModal = true;
  }


  askDeleteNews(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer l'article ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.deleteNews(id);
        } else {
          return;
        }
      });
  }

  deleteNews(newsId: string) {
    this.$http.myressif.ptfBeneficiaireNews
      .deleteNews(newsId)
      .then(() => {
        successAlert.fire({
          title: "Article supprimé avec succès",
          text: "L'article a été supprimé de la liste.",
          icon: "success",
        });
        this.reloadList();
      })
      .catch((error: any) => {
        errorAlert.fire({
          title: "Erreur",
          text: "Une erreur s'est produite lors de la suppression de l'article.",
          icon: "error",
        });
      });
  }
}
